
<template>
  <div>
    <v-dialog 
      v-model="dialog" 
      scrollable 
      persistent 
      :overlay="true" 
      max-width="600px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Editando dados de endereço</span>
        </v-card-title>
        <v-card-text>
          <AddressForm ref="form" :address="address"></AddressForm>
          <AddressProofFiles
            v-if="show_address_proof"
            ref="addressProof"
            :driver_id="$route.params.id"
            :address_proof_files_urls="address_proof_files_urls"
            @uploaded="handleAddressProofUploaded"
          ></AddressProofFiles>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn close @click="closeDialog">Cancelar</f-btn>
          <f-btn save @click="updateAddress">Salvar</f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-loading loadingText="Salvando" v-if="saving"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';

export default {
  name: 'DialogEditAddress',
  components: {
    AddressForm: () => import('@/_backoffice/_registrations/components/shared/forms/AddressForm.vue'),
    AddressProofFiles: () => import('@/_backoffice/_registrations/components/drivers/AddressProofFiles.vue'),
  },
  props: {
    model_address: {
      type: Object,
      required: true,
      default: {
        id: null, 
        addr: null, 
        number: null, 
        complement: null, 
        neighborhood: null, 
        city: null, 
        state: null, 
        zip: null,
        addressable_type: null,
        addressable_id: null
      }
    },
    dialog:{
      type: Boolean,
      default: false
    },
    show_address_proof: {
      type: Boolean,
      default: false
    },
    address_proof_files_urls: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      saving: false,
      address: {}
    }
  },
  methods: {
    setAddress(){
      this.address = JSON.parse(JSON.stringify(this.model_address))
    },
    handleAddressProofUploaded(files) {
      this.$emit('addressProofUpdated', files)
    },
    closeDialog(){
      this.$emit('closeDialog', 'address')
    },  
    updateAddress() {
      if(this.$refs.form.validate()){
        this.saving = true

        let {id, addr, number, complement, neighborhood, city, state, zip, addressable_type, addressable_id,...rest } = this.address
        let address = {id, addr, number, complement, neighborhood, city, state, zip, addressable_type, addressable_id: this.$route.params.id}
        let METHOD = id ? 'update' : 'create' 
        Api.Address[METHOD](address).then(r=> r.data).then(d=> {
          if (!this.show_address_proof) return Promise.resolve()
          return this.$refs.addressProof?.uploadFiles(this.$route.params.id) || Promise.resolve()
        }).then(() => {
          this.successUpdated()
          this.$emit('updated', 'address')
        }).catch(err=>{
          console.log(err)
          this.addNotification({type: 'error',  msg: `Ocorreu um erro! O endereço não foi atualizado.`})
        }).finally(() => {
          this.saving = false
          this.closeDialog()
        })
      }
    },
    ...mapActions({
      addNotification: 'Notification/add'
    })
  },
  mounted () {
    this.setAddress();
  },
}
</script>